import AbstractView from './AbstractView';
import Carousel from 'components/Carousel';
import { mqMobile, mqTabletPortrait } from 'core/MediaQueries';

class Product extends AbstractView {
  registerComponents() {
    super.registerComponents();

    const { $element } = this;
    if (!$element) return null;
    const $carouselBenefits = $element.querySelector('.carousel--benefits');
    if (!$carouselBenefits) return null;
    this.carouselBenefits = new Carousel({
      $element: $carouselBenefits,
      autoLayout: false,
      groupBy: 3,
      breakpoints: [mqTabletPortrait, mqMobile],
      onBreakpointChange(mqls, context) {
        const { $wrapper, $items, length } = context;
        const matchedMqls = mqls.filter((mql) => mql.matches === true);

        if (matchedMqls.length > 0) {
          matchedMqls.forEach((mql) => {
            if (mql.media === mqTabletPortrait) {
              context.groupBy = 2;
              $wrapper.style.width = `${(length / 2) * 100}%`;
            } else if (mql.media === mqMobile) {
              context.groupBy = 1;
              $wrapper.style.width = `${length * 100}%`;
            }
          });
        } else {
          context.groupBy = 3;
          $wrapper.style.width = `${(length / 3) * 100}%`;
        }

        $items.forEach(($item) => ($item.style.width = `${100 / length}%`));
      },
    });
  }

  initialize() {
    super.initialize();

    this.fetchRecommendations();
  }

  fetchRecommendations() {
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product__recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

export default Product;
